const tech_img = require('../../assets/img/tutorials/bernabeu/tech.png');
const secondary_tech_img = require('../../assets/img/tutorials/bernabeu/secondary-tech.png');
const func_img = require('../../assets/img/tutorials/bernabeu/func.png');
const secondary_func_img = require('../../assets/img/tutorials/bernabeu/secondary-func.png');

export const BernabeuSteps = [
    {
        name: 'Santiago Bernabéu',
        title: 'Descripción funcional',
        description: <span>
            <p>El gemelo digital permite la <b>gestión de seguridad de un evento deportivo y sus alrededores, incluyendo calles y accesos</b>. La creación de este modelo digital se basa en la captura y análisis de datos en tiempo real a través de un sistema de <b>cámaras de vigilancia de alta definición</b>, capaces de detectar movimientos de personas, identificar objetos y comportamientos anómalos, y monitorizar flujos de tráfico peatonal y vehicular.
            </p>
            <p>Las cámaras están interconectadas con un centro de control que procesa la información visual utilizando algoritmos avanzados de reconocimiento de patrones y aprendizaje automático. Esto permite la <b>identificación rápida de situaciones potencialmente peligrosas</b>.
            </p>
        </span>,
        secondarydescription: <span>
            <p>Área de Gobierno de Vicealcaldía, Portavoz, Seguridad  y Emergencias</p>
        </span>,
        mainimage: <img src={func_img} alt="main_func" />,
        secondaryimage: <img src={secondary_func_img} alt="sec_func" />,
    },
    {
        name: 'Santiago Bernabéu',
        title: 'Descripción técnica',
        description: <div>
            <span>
                Integraciones técnicas
                <ul>
                    <li><b>Modelos 3D Urbanos</b>: Utilización avanzada de modelos 3D para representar la estructura de la ciudad, permitiendo análisis detallados y simulaciones del espacio urbano.</li>
                    <li><b>Despliegue de Dispositivos IoT</b> para monitorizar y controlar aspectos vitales de la infraestructura urbana.</li>
                    <li><b>Integración de Sistemas de IA</b> utilizando cámaras y sensores para el procesamiento y análisis inteligente de datos visuales, mejorando la seguridad y la planificación urbana.</li>
                </ul>
            </span>
            <span>
                Origen de Datos
                <ul>
                    <li><b>Síntesis de Datos por IoT / IA</b>: Compilación y análisis de datos recogidos por sensores y dispositivos inteligentes, proporcionando una visión holística y actualizada del comportamiento y las necesidades de la ciudad.</li>
                    <li><b>Análisis de Datos de Redes Sociales</b>: Para obtener información sobre las tendencias, opiniones y movimientos de la población en tiempo real.</li>
                </ul>
            </span>

        </div>,
        mainimage: <img src={tech_img} alt="main_tech" />,
        secondaryimage: <img src={secondary_tech_img} alt="sec_tech" />,
    }
];